




















import { Vue, Component, Prop } from "vue-property-decorator";

import { BaseModal } from "@/components/organisms/Modal/BaseModal";

@Component({
  components: { BaseModal },
})
export default class ClearBasket extends Vue {}
